import React from "react";
import "./about.css";


export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <img src="img/FotoMamá.jpeg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-12 col-md-6">
            <div className="about-text">
              <h2>Perfil Profesional</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>¿Por qué consultar?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                        <li key={`${d}-${i}`}>{d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                        <li key={`${d}-${i}`}> {d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
              </div>
              <a href="https://wa.me/+573206646473">
          
              <button className="btn-custom btn-about">Reserva una Cita</button>
        </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
